import Api from "../../../api/index";

const ChampTeam = {
  namespaced: true,
  state: {
    allChampTeams: null
  },

  mutations: {
    setAllChampTeams(state, payload) {
      state.allChampTeams = payload;
    },
    clearChampTeams(state) {
      state.allChampTeams = null;
    }
  },

  actions: {
    index(context, championship_id) {
      return Api.Championship.indexChampTeams(championship_id)
        .then(r => r.data)
        .then(data => {
          context.commit("setAllChampTeams", data);
        });
    },
    update(context, { champTeam }) {
      return Api.Championship.updateChampTeam(champTeam)
        .then(response => response.data)
        .then(team => {})
        .catch(error => {
          console.log({ error });
        });
    }
  }
};

export default ChampTeam;
